import FaqPage from "./FaqPage.container";

export default FaqPage;
